import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { GuiaMedica } from 'src/app/shared/model/guia-medica.model';
import { AtendimentoService } from '../atendimento.service';
import { Atendimento } from 'src/app/shared/model/atendimento.model';
import { ProcedimentoService } from 'src/app/procedimento/procedimento.service';
import { Procedimento } from 'src/app/shared/model/procedimento.model';
import { AuthService } from 'src/app/seguranca/auth.service';
import { User } from 'src/app/shared/model/user.model';
import { AtendimentoEstratificado } from 'src/app/shared/model/atendimento-estratificado.model';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';

@Component({ templateUrl: './cadastro-atendimento.component.html', styleUrls: ['./cadastro-atendimento.component.css'] })
export class CadastroAtendimentoComponent implements OnInit {
  // Reprentar o Usuário Logado
  userLogado: User;

  // Representar a guia médica
  guiaMedica: GuiaMedica;

  // Representar os atendimentos do tipo serviço
  atendimento: Atendimento;
  listaAtendimentos: Array<Atendimento>;

  // Representar os atendimentos do tipo (MEDICAMENTO, MATERIAL, TAXAS E DIÁRIAS)
  atendimentoEstratificado: AtendimentoEstratificado;
  listaAtendimentosEstratificados: Array<AtendimentoEstratificado>;

  // Lista dos usuários que poderão utilizar o plano.
  listaBeneficiarios = [];
  dadosBeneficiarios = [];

  // Lista atendimentos que o usuário tem permissão para visualizar.
  listaProcedimentos = [];

  disabledCPF = false;
  disabledMatricula = false;
  disabledBeneficiarios = true;
  atendimentoIndex: number;
  atendimentoEstratificadoIndex: number;

  indexLista: number;

  // Titulo para exibir no breadcrumb
  tituloPagina: string;
  validarButton: boolean;

  isVisible: boolean;

  constructor(config: NgbModalConfig, private modalService: NgbModal, private activatedRoute: ActivatedRoute,
    private router: Router, private procedimentoService: ProcedimentoService, private atendimentoService: AtendimentoService,
    private toast: ToastrService, private authService: AuthService) {
    // customizar os valores default do modal.
    config.backdrop = 'static';
    config.keyboard = false;
    this.isVisible = false;
    // Inicializar o objeto
    this.guiaMedica = new GuiaMedica();

    this.userLogado = authService.getLoggedUser();
  }

  ngOnInit() {
    // inscrever nos parâmetros de rota, toda a vez que ele mudar mesmo que o componente tenha sido carregado, uma ação será executada.
    this.activatedRoute.params.subscribe(params => {

      // Inicializar as listas
      this.listaAtendimentos = new Array<Atendimento>();
      this.listaAtendimentosEstratificados = new Array<AtendimentoEstratificado>();

      // Atribuir ao objeto da guia médica a lista criada, caso não tenha nenhum atendimento não ocorre erro na API.
      this.guiaMedica.atendimentosEstratificados = this.listaAtendimentosEstratificados;

      // Pegar o guiaId caso seja edição mapeado na URL.
      const guiaMedicaId = params['guiaId'];

      this.tituloPagina = guiaMedicaId ? 'Editar Atendimento' : 'Novo Atendimento';

      // Caso o usuário esteja editando uma guia buscar os dados.
      if (guiaMedicaId) {
        this.buscarGuiaMedica(guiaMedicaId);
      }

      this.listarProcedimentosPorPrestador();
    });
  }

  /**
   * Método responsável por buscar os dados da guia.
   * @param guiaMedicaId identificador da guia médica.
   */
  private buscarGuiaMedica(guiaMedicaId: number) {
    this.atendimentoService.buscar(guiaMedicaId).subscribe(
      (dados) => {

        // Validar se o atendimento foi finalizado, caso seja true redirecionar para uma tela de não autorizado.
        if (this.userLogado.perfil === 1 && dados.finalizado) {
          this.router.navigate(['/nao-autorizado']);
        }

        this.setAtendimento(dados);
      },
      (responseError) => {
        if (responseError instanceof HttpErrorResponse) {
          if (responseError.status === 404) {
            this.router.navigate(['/not-found']);
          } else if (responseError.status === 403) {
            this.router.navigate(['/nao-autorizado']);
          } else {
            this.toast.error('Ocorreu um erro ao processar a sua solicitação');
          }
        }
      }
    );
  }

  /**
   * Método responsável por preparar o modal para registrar um novo atendimento.
   * @param content dados do template do modal.
   */
  modalNovoAtendimento(content) {
    // Inicializar o objeto toda vez que o modal for chamado
    this.atendimento = new Atendimento();

    this.atendimentoIndex = this.listaAtendimentos.length;
    this.modalService.open(content, { size: 'lg' });
  }

  /**
   * Método responsável por preparar o modal para edição de um atendimento.
   * @param content dados do template do modal.
   * @param atendimento objeto com os dados do atendimento.
   * @param index indice atual da linha que será atualizada.
   */
  modalEditarAtendimento(content, atendimento: Atendimento, index: number) {
    this.atendimento = this.cloneAtendimento(atendimento);

    // Atribuir o index do objeto a ser alterado, assim não cadastra um novo.
    this.atendimentoIndex = index;

    this.modalService.open(content, { size: 'lg' });
  }

  /**
   * Método responsável por montar o modal de confirmação da exclusão do atendimento.
   * @param content dados do template do modal.
   * @param index indice da linha que o usuário selecionou.
   */
  modalRemoverAtendimento(content, index) {
    this.indexLista = index;
    this.modalService.open(content, { size: 'lg' });
  }

  /**
   * Método responsável por registrar/atualizar um atendimento (modal).
   * @param form dados do formulário de atendimento.
   */
  salvarAtendimento(form) {
    // Para evitar de limpar o último registro adicionado.
    this.listaAtendimentos[this.atendimentoIndex] = this.cloneAtendimento(this.atendimento);

    // Atribuir ao index o length atual da lista.
    this.atendimentoIndex = this.listaAtendimentos.length;

    // Atribuir a lista de atendimentos a guia médica.
    this.guiaMedica.atendimentos = this.listaAtendimentos;

    // Valida se o botão de salvar pode ser exibido
    this.isVisible = true;

    this.toast.success('Atendimento salvo com sucesso!');
    form.reset();
    this.modalService.dismissAll();
  }

  /**
   * Método para remover um atendimento da lista.
   * @param index indice da linha que será removida da lista.
   * @param tipoAtendimento definir qual o tipo atendimento (SERVIÇO OU ESTRATIFICADO)
   *  SERVIÇO = 1
   *  ESTRATIFICADO = 0
   */
  removerAtendimento(index: number, tipoAtendimento: number) {
    if (tipoAtendimento === 1) {
      this.listaAtendimentos.splice(index, 1);
      this.guiaMedica.atendimentos = this.listaAtendimentos;
    } else {
      this.listaAtendimentosEstratificados.splice(index, 1);
      this.guiaMedica.atendimentosEstratificados = this.listaAtendimentosEstratificados;
    }
    this.toast.success('Atendimento removido com sucesso!');
    this.modalService.dismissAll();
  }

  selectBeneficiado(beneficiado: any) {
    if (this.dadosBeneficiarios !== undefined && this.dadosBeneficiarios.length > 0) {
      const dados = this.dadosBeneficiarios.find(db => db.Nome === beneficiado);
      if (dados.Sexo !== undefined) {
        this.guiaMedica.generoBeneficiado = dados.Sexo === 1 ? 'M' : 'F';
      } else {
        this.guiaMedica.generoBeneficiado = dados.Genero;
      }
      this.guiaMedica.dataNascimentoBeneficiado = new Date(`${moment(dados.Nascimento).format('YYYY-MM-DD HH:mm:ss.SSS')}`);
    }
  }

  // Método para salvar/editar a guia médica.
  saveGuia() {
    // Antes de enviar para a API customizar a matricula para ser enviada sem o código do estabelecimento.
    // this.guiaMedica.matricula =  this.guiaMedica.matricula.substring(3);
    if (typeof this.guiaMedica.beneficiado !== 'undefined') {
      if (this.guiaMedica.id) {
        this.atendimentoService.alterar(this.guiaMedica).subscribe(
          (dados) => {
            this.toast.success('Guia médica alterada com sucesso!');
            this.router.navigate(['/atendimentos/view', dados.id]);
          },
          error => this.toast.error('Erro ao alterar, tente novamente!')
        );
      } else {
        this.atendimentoService.cadastrar(this.guiaMedica).subscribe(
          (dados) => {
            this.toast.success('Guia médica cadastrada com sucesso!');
            this.router.navigate(['/atendimentos/view', dados.id]);
          },
          error => this.toast.error('Erro ao cadastrar, tente novamente!')
        );
      }
    } else {
      this.toast.error('Erro ao cadastrar, selecione um beneficiario');
    }
  }

  /**
   * Método responsável por setar as informações da guia médica.
   * @param guiaMedicaSalva objeto com os dados da guia médica
   */
  private setAtendimento(guiaMedicaSalva: GuiaMedica) {
    this.guiaMedica = guiaMedicaSalva;
    // Método para preencher o combo dos beneficiários.
    this.buildComboBeneficiarios(this.guiaMedica.cpfTitular);

    this.atendimentoIndex = guiaMedicaSalva.atendimentos.length;

    // Atribuir os atendimentos a lista
    this.listaAtendimentosEstratificados = guiaMedicaSalva.atendimentosEstratificados;
    this.atendimentoEstratificadoIndex = guiaMedicaSalva.atendimentosEstratificados.length;

    /**
     * Percorrer a lista de atendimento para armazenar o procedimentoId dos atendimentos
     * TODO: Solução paliativa por conta do select não aceitar um objeto Atendimento.
     */
    guiaMedicaSalva.atendimentos.forEach(atend => {
      let atendimento = new Atendimento();
      atendimento = atend;
      atendimento.procedimentoId = atend.procedimento.id;
      atendimento.procedimento.nome = `${atend.procedimento.codigo} - ${atend.procedimento.nome}`;

      this.listaAtendimentos.push(atendimento);
    });
  }

  /**
   * Método para buscar o valor unitário do procedimento e setar no atendimento que está sendo realizado.
   * @param procedimentoId identificador do procedimento selecionado pelo usuário.
   */
  searchProcedimentoValorUnitario(procedimentoId: any): void {
    this.listaProcedimentos.filter(proc => {
      if (procedimentoId === proc.id) {
        this.atendimento.valorUnitario = proc.valorUnitario;
      }
    });
  }

  /**
   * Método para criar um objeto atendimento.
   * @param atend objeto atendimento com os dados registrados.
   */
  private cloneAtendimento(atend: Atendimento): Atendimento {
    // Criar nova instancia de atendimento
    const atendimento = new Atendimento();
    atendimento.quantidade = atend.quantidade;
    atendimento.valorUnitario = atend.valorUnitario;

    // Validar se é uma atualização ou adição de atendimento.
    if (atend.id) {
      atendimento.procedimentoId = atend.procedimento.id;
      atendimento.procedimento = atend.procedimento;
    } else {
      atendimento.procedimentoId = atend.procedimentoId;
      atendimento.procedimento = this.getProcedimentoPorId(atendimento.procedimentoId);
    }

    return atendimento;
  }

  /**
   * Método para buscar na lista os dados do procedimento adicionado pelo usuário.
   * @param procedimentoId identificador do procedimento a ser buscado.
   */
  private getProcedimentoPorId(procedimentoId: number): Procedimento {
    let procedimento = new Procedimento();
    this.listaProcedimentos.forEach(proc => {
      // Validar se o procedimento é igual ao passado no parâmetro.
      if (proc.id === procedimentoId) {
        procedimento = proc;
      }
    });
    return procedimento;
  }

  // Método responsável por listar todos os procedimentos que o usuário tem permissão.
  private listarProcedimentosPorPrestador() {
    this.procedimentoService.listarProcedimentosPorPrestador(this.userLogado.id).subscribe(
      (dados) => {

        // Percorrer a lista dos procedimentos para concatenar o código do procedimento com o nome para exibir na view.
        dados.forEach(procedimento => {
          const proc = new Procedimento();
          proc.id = procedimento.id;
          proc.nome = `${procedimento.codigo} - ${procedimento.nome}`;
          proc.codigo = procedimento.codigo;
          proc.valorUnitario = procedimento.valorUnitario;
          proc.ativo = procedimento.ativo;

          this.listaProcedimentos.push(proc);
        });
      },
      errorResponse => this.toast.error(errorResponse.error.mensagemUsuario)
    );
  }

  /**
   * Método para validar a quantidade de caracteres digitados e solicitar a busca dos dependentes.
   * @param value cpf do colaborador titular do plano.
   */
  buscarBeneficiarios(cpfTitular: any) {
    this.disabledBeneficiarios = true;
    if (cpfTitular.length === 11) {
      this.buildComboBeneficiarios(cpfTitular);
    }
  }

  /**
   * Método para validar a quantidade de caracteres digitados e solicitar a busca dos dependentes por matricula.
   * @param matricula do colaborador titular do plano.
   */
  buscarBeneficiariosPorMatricula(matricula: any) {
    this.disabledBeneficiarios = true;
    if (matricula.length >= 6) {
      this.buildComboBeneficiarios(matricula);
    }
  }

  /**
   * Método responsável por buscar os dependentes e popular o combo select.
   * Vínculo 2 (Estagiário) = Não tem permissão para utilizar o plano.
   * Caso a data de desligamento esteja preenchida o colaborador não pode usar o plano.
   * @param identificador cpf ou matricula do colaborador titular do plano.
   */
  private buildComboBeneficiarios(identificador) {
    this.atendimentoService.consultarDependentes(identificador).subscribe(
      (dados) => {
         // validar status do colaborador
         if (dados.Bloqueio === false) {
          // validar o plano
          if (dados.Plano === 'PSM') {
            // validar o cargo(precisamos de ajuste)
          if (dados.Vinculo !== 2) {
            // verificar se a data é valida (precisamos de ajuste)
            if (dados.Desligamento === null || this.validarDesligamento(dados.Desligamento)) {
              // Reiniciar lista de beneficiarios.
              this.listaBeneficiarios = [];

              // Adicionar o nome do titular na lista de beneficiários.
              this.listaBeneficiarios.push(dados.Nome);

              // Método para validar se os dependetes podem utilizar o plano AMM.
              this.validarDependentes(dados.Dependentes);
              this.dadosBeneficiarios = dados.Dependentes;

              // Setar dados do titular ao atendimento.
              this.setDadosTitularPlano(dados);

              // Só exibir mensagem e habilitar o combo se estiver cadastrando.
              if (!this.guiaMedica.id) {
                this.disabledBeneficiarios = false;
                this.toast.info('Lista de beneficiários atualizada!');
              } else {
                // Desabilitar o campo de beneficiario e CPF na edição dos atendimentos.
                this.disabledCPF = true;
                this.disabledMatricula = true;
                this.disabledBeneficiarios = true;
              }
            } else {
              this.toast.info('Dados não encontrados na base de dados!');
            }
          } else {
            this.toast.info('Colaborador com vínculo de estagiário não tenho direito ao plano!');
          }
        } else {
          this.toast.info('Colaborador sem acesso a esse plano, entrar em contato com o GPM!');
        }
      } else {
        this.toast.info('Colaborador com pendencias entrar em contato com o GPM!');
      }
      },
      (errorResponse) => {
        this.toast.warning('Dados não encontrados na base de dados!');
      }
    );
  }

  /**
   * Método responsável por setar na guia os dados do titular do plano(Nome, CPF, matricula e código do estabelecimento).
   * @param dados retornados da API de pessoas com os dados do titular do plano.
   */
  private setDadosTitularPlano(dados) {
    this.guiaMedica.nomeTitular = dados.Nome;
    this.guiaMedica.cpfTitular = dados.CPF;

    // Método para formatar a matricula caso seja menor que 4 digitos.
    // const matriculaAjustadaHCM = this.ajustarMatricula(dados.Matricula);

    // Concatenar o valor do código estabelecimento + matricula para exibir na view igual a carteira do plano para o usuário.
    // this.guiaMedica.matricula = `${dados.EstabelecimentoCodigo}${matriculaAjustadaHCM}`;
    this.guiaMedica.matricula = `${dados.Matricula}`;
    this.guiaMedica.estabelecimentoCodigo = Number(`${dados.EstabelecimentoCodigo}`.substring(4, 7));
    this.guiaMedica.generoBeneficiado = dados.Sexo === 1 ? 'M' : 'F';
    this.guiaMedica.dataNascimentoBeneficiado = new Date(`${moment(dados.Nascimento).format('YYYY-MM-DD HH:mm:ss.SSS')}`);
  }

  /**
   * Método responsável por formatar a matricula do colaborador para quatro digitos para seguir o padrão do sistema.
   * TODO: Revalidar esse método. Foi implementado essa validação porque a API de pessoas só aceita 4 digitos para buscar os dependentes.
   * @param matricula matricula do colaborador.
   */
  private ajustarMatricula(matricula) {
    let novaMatricula = matricula;
    if (matricula.toString().length === 3) {
      novaMatricula = `0${matricula}`;
    }

    if (matricula.toString().length === 2) {
      novaMatricula = `00${matricula}`;
    }

    return novaMatricula;
  }

  /**
   * Método para validar quais dependentes podem utilizar o plano de saúde.
   *  Podem utilizar o plano o grau de parentesco 1 (filho), podem utilizar até a idade 17 anos 11 meses e 30 dias.
   *  Podem utilizar o plano o grau de parentesco 2 (cônjuge)
   *  Podem utilizar o plano o grau de parentesco 4 (Companheiro)
   * @param dependentes informações dos dependentes que retornam da API.
   */
  private validarDependentes(dependentes) {
    dependentes.forEach(dependete => {
      if (dependete.GrauParentesco === 1 || dependete.GrauParentesco === 2 || dependete.GrauParentesco === 4) {
        if (dependete.GrauParentesco === 1) {
          // Data de nascimento do dependente formatada.
          const dataNascimento = moment(dependete.Nascimento).format('YYYY-MM-DD');

          // Calcular duração do intervalo.
          const duration = moment.duration(moment(new Date()).diff(dataNascimento));

          // Validar se a duração em dias menor que 6575 = 18 anos
          if (duration.asDays() < 6575 || dependete.IsEspecial) {
            this.listaBeneficiarios.push(dependete.Nome);
          }
        } else {
          this.listaBeneficiarios.push(dependete.Nome);
        }
      }
    });
  }

  /***********************************  BLOCO DE MÉTODOS UTILIZADOS PARA O ATENDIMENTO ESTRATIFICADO *****************************/

  /**
   * Método responsável por preparar o modal para registrar um novo atendimento estratificado.
   * @param content dados do template do modal.
   */
  modalNovoAtendimentoEstratificado(content) {
    // Inicializar o objeto toda vez que o modal for chamado
    this.atendimentoEstratificado = new AtendimentoEstratificado();

    this.atendimentoEstratificadoIndex = this.listaAtendimentosEstratificados.length;

    this.modalService.open(content, { size: 'lg' });
  }

  /**
   * Método responsável por registrar/atualizar um atendimento do tipo estratificado (modal).
   * @param form dados do formulário.
   */
  salvarAtendimentoEstratificado(form) {
    // Para evitar de limpar o último registro adicionado.
    this.listaAtendimentosEstratificados[this.atendimentoEstratificadoIndex] =
      this.cloneAtendimentoEstratificado(this.atendimentoEstratificado);

    // Atribuir ao index o length atual da lista.
    this.atendimentoEstratificadoIndex = this.listaAtendimentosEstratificados.length;

    // Atribuir a lista de atendimentos estratificados a guia médica.
    this.guiaMedica.atendimentosEstratificados = this.listaAtendimentosEstratificados;

    // Valida se o botão de salvar pode ser exibido
    this.isVisible = true;

    this.toast.success('Atendimento salvo com sucesso!');
    form.reset();
    this.modalService.dismissAll();
  }

  private validarDesligamento(desligamento: string): boolean {
    const dataDesligamento = new Date(desligamento);
    if (dataDesligamento.getTime() > Date.now()) {
      return true;
    }
    return false;
  }

  /**
   * Método responsável por preparar o modal para edição de um atendimento.
   * @param content dados do template do modal.
   * @param atendimento objeto com os dados do atendimento.
   * @param index indice atual da linha que será atualizada.
   */
  modalEditarAtendimentoEstratificado(content, atendimento: AtendimentoEstratificado, index: number) {
    this.atendimentoEstratificado = this.cloneAtendimentoEstratificado(atendimento);

    // Atribuir o index do objeto a ser alterado, assim não cadastra um novo.
    this.atendimentoEstratificadoIndex = index;

    this.modalService.open(content, { size: 'lg' });
  }

  /**
   * Método para criar um novo objeto atendimento estratificado.
   * @param atend objeto atendimento com os dados registrados.
   */
  private cloneAtendimentoEstratificado(atend: AtendimentoEstratificado): AtendimentoEstratificado {
    const atendimento = new AtendimentoEstratificado();
    atendimento.nome = atend.nome;
    atendimento.tipo = atend.tipo;
    atendimento.valor = atend.valor;

    return atendimento;
  }
}
